const vestnikyPrefixPath = '/internal/vestniky';
const indexerPrefixPath = '/vyhladavanie';
const ciselnikyPrefixPath = '/external/ciselniky';

export {
  vestnikyPrefixPath, indexerPrefixPath, ciselnikyPrefixPath,
};
